import moment from 'moment';
import _ from 'lodash';

class TimesheetGridController {
  constructor($scope) {
    "ngInject";
    this.$scope = $scope;
    this.dateRange = [];
    this.chargeCodes = [];
    this.nonLeaveChargeCodes = [];
    this.leaveChargeCodes = [];
  }

  $onInit() {
    this.updateTimesheetData();
  }

  $onChanges(changes) {
    if (changes.timesheet && (!changes.timesheet.previousValue || changes.timesheet.currentValue !== changes.timesheet.previousValue)) {
      this.updateTimesheetData();
    }
  }

  updateTimesheetData() {
    if (!this.timesheet) {
      this.dateRange = [];
      this.chargeCodes = [];
      this.nonLeaveChargeCodes = [];
      this.leaveChargeCodes = [];
      return;
    }

    // Calculate date range once and cache it
    this.dateRange = this.calculateDateRange();
    
    // Calculate charge codes once and cache them
    this.chargeCodes = this.calculateChargeCodes();
    this.nonLeaveChargeCodes = this.chargeCodes.filter((cc) => !cc.leaveType);
    this.leaveChargeCodes = this.chargeCodes.filter((cc) => cc.leaveType);
  }

  calculateDateRange() {
    if (!this.timesheet || !this.timesheet.startDate || !this.timesheet.endDate) {
      return [];
    }

    const dates = [];
    const startDate = moment(this.timesheet.startDate);
    const endDate = moment(this.timesheet.endDate);
    let currentDate = moment(startDate);

    while (currentDate.isSameOrBefore(endDate)) {
      // Clone the moment object to avoid mutation issues
      dates.push(moment(currentDate).clone());
      currentDate.add(1, 'days');
    }

    return dates;
  }

  getDateRange() {
    return this.dateRange;
  }

  calculateChargeCodes() {
    if (!this.timesheet || !this.timesheet.timeEntries) {
      return [];
    }

    const chargeCodes = [];
    this.timesheet.timeEntries.forEach((timeEntry) => {
      if (!_.find(chargeCodes, (cc) => cc.name === timeEntry.chargeCode.name)) {
        chargeCodes.push(timeEntry.chargeCode);
      }
    });

    return chargeCodes;
  }

  getChargeCodes() {
    return this.chargeCodes;
  }

  getNonLeaveChargeCodes() {
    return this.nonLeaveChargeCodes;
  }

  getLeaveChargeCodes() {
    return this.leaveChargeCodes;
  }

  hasNonLeaveTimeEntries() {
    return this.nonLeaveChargeCodes.length > 0;
  }

  hasTimeEntries() {
    return this.timesheet && this.timesheet.timeEntries && this.timesheet.timeEntries.length > 0;
  }

  showLeaveChargeCode(chargeCode) {
    // Show if there are any time entries for this charge code
    return this.timesheet.timeEntries.some((te) => te.chargeCode.name === chargeCode.name);
  }

  getTimeEntryHours(chargeCode, date) {
    if (!this.timesheet || !this.timesheet.timeEntries) {
      return undefined;
    }

    const timeEntry = _.find(this.timesheet.timeEntries, (te) => {
      const sameDate = moment(te.date).isSame(moment(date), 'day');
      const sameChargeCode = te.chargeCode.name === chargeCode.name;
      return sameDate && sameChargeCode;
    });

    return timeEntry && timeEntry.hours ? parseFloat(timeEntry.hours) : undefined;
  }

  getTotalChargeCodeTime(chargeCodeName) {
    if (!this.timesheet || !this.timesheet.timeEntries) {
      return 0;
    }

    const entries = _.filter(this.timesheet.timeEntries, (te) => te.chargeCode.name === chargeCodeName);
    return _.sumBy(entries, (te) => parseFloat(te.hours) || 0);
  }

  getDailyTotal(date) {
    if (!this.timesheet || !this.timesheet.timeEntries) {
      return 0;
    }

    const entries = _.filter(this.timesheet.timeEntries, (te) => moment(te.date).isSame(moment(date), 'day'));
    return _.sumBy(entries, (te) => parseFloat(te.hours) || 0);
  }

  getTotalTime() {
    if (!this.timesheet || !this.timesheet.timeEntries) {
      return 0;
    }

    return _.sumBy(this.timesheet.timeEntries, (te) => parseFloat(te.hours) || 0);
  }

  isWeekend(date) {
    const day = moment(date).weekday();
    return day === 0 || day === 6;
  }

  isCurrentDay(date) {
    return moment(date).isSame(moment(), 'day');
  }

  isSelectedDay(date) {
    // For read-only display, we don't need selection
    return false;
  }
}

export default TimesheetGridController;




// WEBPACK FOOTER //
// ./client/common/directives/timesheet-grid/timesheet-grid.controller.js